module.exports = __webpack_public_path__ + "static/media/Teil_1_Backward.53220f2d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_1_Backward.mp4
// module id = 112
// module chunks = 0